const BusinessWrapper = ({ children }) => children;

export default BusinessWrapper;
